<template>
  <ListTemplate
    :fields="fields"
    :api-url="apiURL"
    title="Email Templates"
  />
</template>

<script>
/**
 * List view of a groups email templates
 */
import ListTemplate from '@/components/ListTemplate'
import groupAPI from '@/api/group'

export default {
  components: {
    ListTemplate,
  },
  props: {
    /** group */
    groupId: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      fields: [
        {
          name: 'name',
          title: 'Name',
          linkToIndex: true,
        },
        {
          name: 'template_type',
          title: 'Type',
        },
        {
          name: 'actions',
          title: 'Actions',
          titleClass: 'center aligned',
          dataClass: 'center aligned',
        },
      ],
    }
  },
  computed: {
    apiURL () {
      return groupAPI.emailTemplatesURL(this.groupId)
    },
  },
}
</script>
